// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DevicesCard_wrapper__3Mx9v"};